export default () => (
    <img
        alt="Not found"
        src={'/assets/images/not_found.png'}
        style={{ maxWidth: '90vw', maxHeight: '90vh', margin: 'auto', display: 'block' }}
    />
);
